module.exports = __webpack_public_path__ + "static/media/DSC01493.e80837d0.jpg";